import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";
import { toMoney } from "../../util/Utils";
import { Box, TextField } from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { useState } from "react";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";

export default function ConsultantOrdersDetails(props) {
  const { isSmall } = useBreakpoints();
  const [pageState, setPageState] = useState({
    page: 1,
  });

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },

    {
      field: "productName",
      headerName: "محصول",
      width: 300,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "productCount",
      headerName: "تعداد",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.productCount
              ? toMoney(cellValues.row.productCount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalCost",
      headerName: "مجموع",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalCost ? toMoney(cellValues.row.totalCost) : 0}
          </Typography>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      maxWidth="md"
      open={props.openDialoge.show}
      onClose={() =>
        props.setOpenDialoge({ ...props.openDialoge, show: false })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        جزئیات گزارش فروش مشاور {props.openDialoge.model?.fullname}
      </DialogTitle>
      <DialogContent>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد محصولات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.productCount
                  ? toMoney(props.openDialoge.model?.productCount)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.orderCount
                  ? toMoney(props.openDialoge.model?.orderCount)
                  : "0"
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مجموع سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.orderCost
                  ? toMoney(props.openDialoge.model?.orderCost)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box sx={{ height: "30rem" }} gridColumn="span 12">
            {props.openDialoge.model ? (
              <DataGrid
                className="ltr-grid"
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={
                  props.openDialoge.model ? props.openDialoge.model.items : []
                }
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={
                  props.openDialoge.model.items &&
                  props.openDialoge.model.items.length
                    ? props.openDialoge.model.items.length
                    : 1
                }
                enableRangeSelection={true}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    isLtr: true,
                    nofab: true,
                    rowCount:
                      props.openDialoge.model.items &&
                      props.openDialoge.model.items.length
                        ? props.openDialoge.model.items.length
                        : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "rowIndex",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              onClick={() =>
                props.setOpenDialoge({ ...props.openDialoge, show: false })
              }
              color="secondary"
              variant="contained"
            >
              بستن
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
